import { render, staticRenderFns } from "./pedido.vue?vue&type=template&id=3fb1c7fe&scoped=true&"
import script from "./pedido.vue?vue&type=script&lang=js&"
export * from "./pedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1c7fe",
  null
  
)

export default component.exports